import { render, staticRenderFns } from "./QuestionsSection.vue?vue&type=template&id=5e5af1aa&scoped=true&"
import script from "./QuestionsSection.vue?vue&type=script&lang=js&"
export * from "./QuestionsSection.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsSection.vue?vue&type=style&index=0&id=5e5af1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5af1aa",
  null
  
)

export default component.exports